import { useState, Fragment } from "react";
import { Table, Tr, Th, Td, ClickableTr, DetailTr, DetailTd, DetailBox } from "../atoms/Table";
import { StatusBadge } from "../atoms/StatusBadge";
import { getVisitStatus } from "../../lib/visitStatus";
import { useEvent } from "../../contexts/EventContext";
import { STATUS_CONFIG } from "../atoms/StatusBadge";

export function VisitorTable({ rows }) {
  const data = rows;
  const [openSet, setOpenSet] = useState(() => new Set());
  const { eventDate } = useEvent();
  const [hoverIndex, setHoverIndex] = useState(null);

  // 複数詳細行を開けるようにする
  const toggleRow = (index) => {
    setOpenSet((prev) => {
      const next = new Set(prev);
      if (next.has(index)) next.delete(index);
      else next.add(index);
      return next;
    });
  };

  return (
    <Table>
      <thead>
        <tr>
          <Th>氏名</Th>
          <Th>会社名</Th>
          <Th>業種</Th>
        </tr>
      </thead>

      <tbody>
        {data.map((r, i) => {
          const isOpen = openSet.has(i);

          const status = getVisitStatus({
            preferredVisitText: r.preferred_visit_date,
            targetDate: eventDate,
            visited: r.visited,
          });

          // statusによって行の色変更とHoverの処理を行う
          const isHover = hoverIndex === i;
          const rowStyle = {
            background: isHover
              ? STATUS_CONFIG[status]?.rowHover
              : STATUS_CONFIG[status]?.rowColor,
          };

          return (
            <Fragment key={i}>
              <ClickableTr
                style={rowStyle}
                onClick={() => toggleRow(i)}
                onMouseEnter={() => setHoverIndex(i)}
                onMouseLeave={() => setHoverIndex(null)}
              >
                <Td>
                  {r.visitor_name}

                  {status !== "ready" && (
                    <span style={{ marginLeft: 8 }}>
                      <StatusBadge status={status} />
                    </span>
                  )}
                </Td>
                <Td>{r.company_name}</Td>
                <Td>{r.industry}</Td>
              </ClickableTr>

              {isOpen && (
                <DetailTr>
                  <DetailTd colSpan={3}>
                    <DetailBox>
                      <VisitorDetailTable row={r} />
                    </DetailBox>
                  </DetailTd>
                </DetailTr>
              )}
            </Fragment>
          );
        })}
      </tbody>
    </Table>
  );
}

function VisitorDetailTable({ row }) {
  return (
    <>
      <DetailAccordionItem label="基本情報">
        <Table>
          <tbody>
            <Tr><Th>読み</Th><Td>{row.visitor_name_kana}</Td></Tr>
            <Tr><Th>部署</Th><Td>{row.department_name}</Td></Tr>
            <Tr><Th>役職</Th><Td>{row.position_name}</Td></Tr>
            <Tr><Th>郵便番号</Th><Td>{row.postal_code}</Td></Tr>
            <Tr><Th>住所</Th><Td>{[row.prefecture, row.municipality, row.address, row.building_name].join("")}</Td></Tr>
            <Tr><Th>電話番号</Th><Td>{row.phone_number}</Td></Tr>
          </tbody>
        </Table>
      </DetailAccordionItem>

      <DetailAccordionItem label="申込イベント情報">
        <Table>
          <tbody>
            <Tr><Th>申込イベント</Th><Td>{row.event_name}</Td></Tr>
            <Tr><Th>来場希望日</Th><Td>{row.preferred_visit_date.join(",　")}</Td></Tr>
            <Tr>
              <Th>どこからこのイベントを知ったか</Th>
              <Td>
                {
                  row.event_source === "代理店" ? [row.event_source, row.event_source_agency_text].join("　")
                  : row.event_source === "その他" ? row.event_source_other_text
                  : row.event_source
                }
              </Td>
            </Tr>
            <Tr><Th>どなたから案内があったか</Th><Td>{row.invitation_from}</Td></Tr>
            <Tr><Th>交通手段</Th>
              <Td>
                {
                  row.visit_transportation === "その他" ? row.visit_transportation_other_text
                  : row.visit_transportation
                }
              </Td>
            </Tr>
          </tbody>
        </Table>
      </DetailAccordionItem>

      <DetailAccordionItem label="申込セミナー">
        {row.applied_seminars?.length ? (
          <ul>
            {row.applied_seminars.map((s, i) => (
              <li key={i}>{s}</li>
            ))}
          </ul>
        ) : (
          <p>申込無し</p>
        )}
      </DetailAccordionItem>
    </>
  );
}

function DetailAccordionItem({ label, children }) {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ marginBottom: 8 }}>
      <div
        style={{
          cursor: "pointer",
          fontWeight: "bold",
          padding: "6px 0",
        }}
        onClick={() => setOpen((v) => !v)}
      >
        {open ? "▼ " : "▶ "} {label}
      </div>

      {open && (
        <div style={{ paddingLeft: 16 }}>
          {children}
        </div>
      )}
    </div>
  );
}